export default __webpack_public_path__ + "867b4af2862aefd87e77b9ce5f32707c.png";